import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "../lib/api";

export const Hero = () => {
  const [mainImg, setMainImg] = useState(null);
  const [smallImg, setSmallImg] = useState(null);
  const [featured, setFeatured] = useState(null);

  useEffect(() => {
    // Prefer Rouge Amb 56 for the main and Sauvage Amb 60 for the small overlay
    api.get("/products").then((r) => {
      const list = r.data || [];
      const rouge = list.find((p) => p.name === "Rouge Amb 56");
      const sauvage = list.find((p) => p.name === "Sauvage Amb 60");
      const main = rouge || list[0];
      if (main) {
        setMainImg(main.image_url || null);
        setFeatured(main);
      }
      if (sauvage) setSmallImg(sauvage.image_url);
      else if (list.length > 1) setSmallImg(list[1].image_url);
    }).catch(() => {});
  }, []);

  return (
    <section
      data-testid="hero-section"
      className="relative overflow-hidden border-b border-[#2D2622]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 pt-16 md:pt-24 pb-20 md:pb-32 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-6 items-end">
        <div className="md:col-span-7 md:pr-10">
          <p
            data-testid="hero-overline"
            className="text-[11px] tracking-overline uppercase font-bold text-[#D4AF37] mb-8"
          >
            Vol. 01 · Winter Edit · MMXXVI
          </p>

          <h1
            data-testid="hero-title"
            className="font-serif-display font-light text-[64px] sm:text-[88px] md:text-[120px] lg:text-[148px] leading-[0.85] tracking-[-0.04em] text-[#F4EAD9]"
          >
            Bottled
            <br />
            <span className="italic text-[#D4AF37]">memory</span>,
            <br />
            poured slow.
          </h1>

          <div className="mt-12 max-w-md">
            <p className="text-base md:text-lg leading-relaxed text-[#B0A496]">
              A small atelier composing fragrances around moments — a monsoon afternoon,
              a winter ballroom, a Tuesday at the desk. Find yours below.
            </p>

            <div className="mt-10 flex items-center gap-6">
              <Link
                data-testid="hero-cta-shop"
                to="/shop"
                className="inline-flex items-center gap-3 bg-[#D4AF37] hover:bg-[#B8941F] text-[#15110F] px-8 py-4 text-[11px] tracking-overline uppercase font-bold transition-colors"
              >
                Explore the catalog
                <ArrowUpRight size={16} strokeWidth={1.2} />
              </Link>
              <Link
                data-testid="hero-cta-best"
                to="/shop?best=1"
                className="editorial-link text-[11px] tracking-overline uppercase font-bold text-[#F4EAD9]"
              >
                Best sellers
              </Link>
            </div>
          </div>
        </div>

        <div className="md:col-span-5 relative">
          <div className="relative aspect-[3/4] image-zoom-parent overflow-hidden bg-[#1F1A17]">
            {mainImg && (
              <img
                data-testid="hero-image"
                src={mainImg}
                alt={featured?.name || "Featured perfume"}
                className="image-zoom w-full h-full object-cover"
              />
            )}
          </div>
          {smallImg && (
            <div className="hidden md:block absolute -bottom-10 -left-12 w-44 aspect-square overflow-hidden border border-[#2D2622] bg-[#0F0C0A]">
              <img
                src={smallImg}
                alt="Featured perfume"
                className="w-full h-full object-cover"
              />
            </div>
          )}
          <p className="mt-6 md:mt-10 text-[11px] tracking-overline uppercase font-bold text-[#D4AF37]">
            {featured ? featured.name : "New this season"}
          </p>
        </div>
      </div>

      <div className="border-t border-[#2D2622] overflow-hidden">
        <div className="drift flex gap-12 whitespace-nowrap py-5 text-[11px] tracking-overline uppercase font-bold text-[#D4AF37]">
          {Array.from({ length: 2 }).map((_, i) => (
            <div key={i} className="flex gap-12 shrink-0">
              <span>Hand-decanted in 30ml</span>
              <span>·</span>
              <span>Cruelty-free always</span>
              <span>·</span>
              <span>Free shipping PAN India</span>
              <span>·</span>
              <span>Composed in India</span>
              <span>·</span>
              <span>Try before you buy — sample sets</span>
              <span>·</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
